export default {"src":"/_next/static/media/PPT.63ad30fb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};